// extracted by mini-css-extract-plugin
module.exports = {"background":"az_jcb","container":"az_kcb"};